<template>
    <div>

        <config-main-title>
            CNAE: {{ unidade ? unidade.st_nome : '?' }} 
        </config-main-title>

        <div>

            <div class="form-row mb-3">
                <div class="col col-12 col-md-6 d-flex flex-column">
                    <az-input icon="fas fa-search" v-model="search" />
                </div>
                <div class="col col-12 col-md-3 d-flex flex-column">
                    <div class="btn-group mb-1" role="group" aria-label="Basic example">
                        <button type="button" class="btn" :class="viewMode == 'A' ? 'btn-secondary' : 'btn-outline-secondary'" 
                        @click="viewMode = 'A'">
                            Ativos
                        </button>
                        <button type="button" class="btn" :class="viewMode == 'T' ? 'btn-secondary' : 'btn-outline-secondary'" 
                        @click="viewMode = 'T'">
                            Todos
                        </button>
                    </div>
                </div>
                <div class="col col-12 col-md-3 d-flex flex-column">
                    <button type="button" class="btn btn-outline-success" @click="incluir ()">
                        Incluir CNAE
                    </button>
                </div>
            </div>

        </div>

        <div v-if="( !lista || !lista.length )">
            <az-empty-state 
                :msg="'Nenhum CNAE identificado.'" 
                icon="fas fa-search" />
		</div>

        <div v-if="lista && lista.length">

            <div class="list-group mb-3 az-anime-surgir mb-3">
                <li class="list-group-item d-flex justify-content-between" v-for="(dado, id) in lista" :key="id">
                    <span>
                        <a href="#" @click.prevent="editar(dado)" class="h5 card-link mb-0 mr-3">
                            {{ dado.search }}
                        </a>
                        <big data-toggle="tooltip" data-placement="top" title="Teto para data futura" 
                            v-if="dado.dt_inicio_vigencia > $util.hoje()">
                            <i class="fas fa-plane-departure mr-2"></i>
                        </big>
                        <big data-toggle="tooltip" data-placement="top" title="Teto com vigência já passada" 
                            v-if="dado.dt_final_vigencia < $util.hoje()">
                            <i class="fas fa-history mr-2"></i>
                        </big>
                    </span>
                    <span>
                        <div class="custom-control custom-switch" v-if="viewMode == 'T'">
                            <input type="checkbox" class="custom-control-input" 
                                :id="'ativo-' + id" 
                                v-model="dado.fl_ativo" 
                                @change="toggle(dado)">
                            <label class="custom-control-label" :for="'ativo-' + id"></label>
                        </div>
                        <div v-else>
                            <span class="badge badge-secondary" v-if="dado.filtros.length">
                                <i class="fa fa-filter mr-1" aria-hidden="true"></i>
                                {{ dado.filtros.length }}
                            </span>
                        </div>
                    </span>
                </li>
            </div>

        </div>

        <!-- Formulário de edição -->
        <div class="modal fade" id="edicaoModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
            <div class="modal-dialog modal-xl" role="document">
                <div class="modal-content" v-if="item">
                    <div class="modal-header">
                        <h5 class="modal-title" id="exampleModalLabel">
                            {{ item && item.id_cnae ? '' : 'Nova' }}
                            CNAE
                            {{ item && item.id_cnae ? '#' + item.id_cnae : '' }}
                        </h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body" v-if="item">
                        <div class="row">
                            <div class="col col-12 col-md-8">
                                <az-input
                                    type="number"
                                    label="Código CNAE"
                                    placeholder="CNAE..."
                                    :validate="validate"
                                    required
                                    v-model="item.st_codigo" />
                            </div>
                            <div class="col col-12 col-md-4">
                                <az-input
                                    label="Alíquota ISS"
                                    placeholder="Padrão..."
                                    type="number"
                                    :validate="validate"
                                    v-model="item.dc_aliquota_iss" />
                            </div>
                        </div>

                        <div class="row">
                            <div class="col col-12">
                                <az-input
                                    label="Código do item na lista de serviços"
                                    placeholder="Item na lista de serviços..."
                                    :validate="validate"
                                    required
                                    v-model="item.st_item_servico" />
                            </div>
                        </div>

                        <div class="row">
                            <div class="col col-12">
                                <az-input
                                    label="Código de tributação no município"
                                    placeholder="Código de tributação..."
                                    :validate="validate"
                                    v-model="item.st_codigo_tributacao" />
                            </div>
                        </div>

                        <div class="row" v-if="item.ch_nfse_servico == '1'">
                            <div class="col col-12">
                                <az-input
                                    label="Código de Situação Tributária (CST)"
                                    type="select"
                                    optionsMode="json"
                                    :optionsList="situacao_tributaria"
                                    optionsData="id"
                                    v-model="item.st_codigo_situacao_tributaria" />
                            </div>
                        </div>

                        <div class="row">
                            <div class="col col-12 col-md-3">
                                <az-input
                                    label="Código NBS"
                                    placeholder="Código NBS..."
                                    v-model="item.st_codigo_nbs" />
                            </div>
                            <div class="col col-12 col-md-3" v-if="item.ch_nfse_servico != '1'">
                                <az-input
                                    label="Classificação Tributária"
                                    placeholder="Classificação Tributária..."
                                    v-model="item.st_classificacao_tributaria" />
                            </div>
                            <div class="col col-12 col-md-3">
                                <az-input
                                  label="Código de Situação Tributária (CST)"
                                  placeholder="CST"
                                  :maxlength="3"
                                  v-model="item.st_codigo_situacao_tributaria"
                                />
                            </div>
                            <div class="col col-12 col-md-3">
                                <az-input
                                    label="Indicador de Operação"
                                    placeholder="Indicador de Operação..."
                                    v-model="item.st_indicador_operacao" />
                            </div>
                        </div>

                        <div class="row">
                            <div class="col col-12">
                                <az-input
                                    label="Descrição"
                                    placeholder="Descrição (Opcional)..."
                                    :validate="validate"
                                    v-model="item.st_titulo" />
                            </div>
                        </div>

                        <div class="row">
                            <div class="col col-12">
                                <az-input
                                    type="textarea"
                                    rows="3"
                                    label="Observações"
                                    placeholder="(Opcional)..."
                                    :validate="validate"
                                    v-model="item.st_obs" />
                            </div>
                        </div>

                        <!-- Filtros -->
                        <filtro-model class="my-3" v-model="item.filtros" :validate="validate" :opcoes="lista_opcoes_filtro" />

                    </div>
                    <div class="modal-footer">
                        <az-audit-log-button model="cnae" :id="item.id_cnae" />
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Fechar</button>
                        <az-submit @click="atualizar ()">{{ item.id_cnae ? 'Atualizar' : 'Incluir' }}</az-submit>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
import _ from 'lodash';
import $ from 'jquery';
import ConfigMainTitle from '../shared/ConfigMainTitle.vue';
import AzInput from '../../shared/forms/AzInput.vue';
import AzEmptyState from '../../util/AzEmptyState.vue';
import AzSubmit from '../../util/AzSubmit.vue';
import AzAuditLogButton from '../../util/AzAuditLogButton.vue';
import FiltroModel from '../shared/FiltroModel.vue';

export default {
    data () { 
        return { 
            dados: null, 
            em_edicao: false, 
            item: null, 
            validate: false,
            search: "", 
            viewMode: "A",
            title: "",
            situacao_tributaria: [
                { id: "0", search: "0 - Tributada integralmente" },
                { id: "5", search: "5 - Tributada integralmente e sujeito ao regime de substituição tributária pelo agenciador ou intermediário da prestação do serviço" },
                { id: "8", search: "8 - Tributada com redução da base de cáculo ou alíquota" },
                { id: "12", search: "12 - Isenta ou imune" },
                { id: "13", search: "13 - Não tributada" },
                { id: "14", search: "14 - Tributada por meio de imposto fixo" },
                { id: "15", search: "15 - Não tributada em razão dos destinos dos bens ou objetos - Mercadorias para industrialização ou comercialização" },
                { id: "16", search: "16 - Não tributada em razão do diferimento da prestação do serviço" },
            ], 
            short_title: "", 
            service: "",
        }
    },

    props: ['id_unidade_operacao'],

    components: { 
        ConfigMainTitle,
        AzInput,
        AzEmptyState,
        AzSubmit,
        AzAuditLogButton,
        FiltroModel
    },

    computed: { 
        lista_opcoes_filtro: function () { 
            let opcoes = [                        
                {id:'App\\azure\\classeProcedimento', search:'Classe do Procedimento', service: 'classe_procedimentos.index'}, 
                {id:'App\\azure\\especialidade', search:'Especialidade', service: 'especialidades.index'}, 
                {id:'App\\azure\\plano', search:'Operadora/Plano', service: 'planos.index', nosync: true}, 
                {id:'App\\azure\\operadora', search:'Operadora', service: 'operadoras.index'}, 
                {id:'App\\azure\\procedimento', search:'Procedimento', service: 'procedimentos.index'},
                {id:'App\\azure\\medico', search:'Prestador', service: 'medicos.index'},
            ];

            return opcoes;
        },

        lista_filtros: function () { 

            if ( !this.item ) 
                return [];

            return this.item.filtros.filter(item => !item.excluido);

        },

        lista: function () { 
            let pesquisar = this.search.trim();
            let parts = pesquisar.replace(' ','.*');
            let match = parts;
            let reg = new RegExp(match, 'i');

            return this.dados && this.dados.length ? 
                this.dados.filter (item => { 
                    return ( this.viewMode == 'T' || item.fl_ativo ) && 
                        ( !this.search || reg.test(JSON.stringify(item)) );
                }) : null;
        },

        unidade: function () { 
            return this.$util.unidade_operacao(this.id_unidade_operacao);
        },
    },

    methods: { 
        
        incluir () { 
            this.validate = false;

            let item = {
                id_cnae: null, 
                id_unidade_operacao: this.id_unidade_operacao, 
                fl_ativo: true, 
                st_codigo: "",
                st_item_servico: "",
                st_codigo_tributacao: "",
                st_codigo_situacao_tributaria: "",
                st_codigo_nbs: "",
                st_classificacao_tributaria: "",
                st_indicador_operacao: "",
                st_titulo: "",
                st_obs: "", 
                filtros: [],
            };

            this.editar (item);
        },
        load () { 
            this.$util.load(this, { 
                service:'cnaes',
                func: 'index',
                parms: { 
                    cadastro: true, 
                    id_unidade_operacao: this.id_unidade_operacao, 
                },
            });
        },
        editar (item) { 
            this.validate = false;
            this.item = _.cloneDeep (item);

            $('#edicaoModal').modal('show');
        },
        atualizar () { 
            this.$util.atualizar(this, { 
                service: 'cnaes',
                dados: this.item,
                reload: true, 
                modal: 'edicaoModal',
            });
        },

        toggle (item) { 

            this.$util.toggle(this, { 
                service: 'cnaes',
                dados: item,
            });

        },
    },

    mounted () { 
        this.load ();

        this.$store.commit('setBreadcrumb',
              [
                { name: "Configurações", path: "/cadastros" },
                { name: "Unidades, Centros de Custo", path: "/config/unidades" },
                { name: "CNAE", path: "/config/unidades/" + this.id_unidade_operacao + "/cnae/" },
              ]);
    },

    updated () { 
        $('[data-toggle="tooltip"]').tooltip();
    }


}
</script>
